module.exports = __webpack_public_path__ + "static/media/stars-trustpilot-five.c06dbdf5.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/resources/stars-trustpilot-five.svg
// module id = 3446
// module chunks = 0